export default __webpack_public_path__ + "static/media/block-who-we-help-1.4d544a13.webp";